let jobArray = []

const greenhouseURL = 'https://boards-api.greenhouse.io/v1/boards/pelacase/departments';
$.getJSON(greenhouseURL,(data => {
    data.departments.forEach((item) => {
        if (item.jobs.length != 0) {
            jobArray += `<div class="department-header"><h3>${item.name}</h3></div>`;
        }
        item.jobs.forEach((job) => {
            let remote = false;
            job.metadata.forEach((metadata) => {
                if(metadata.name == 'Remote'){
                    remote = metadata.value;
                }
            });
            let structuredHTML = (
                `<a href="${job.absolute_url}" class="unstyled full-unstyled-link careers-summary-bar__container">
                    <div class="careers-summary-bar">
                        <div class="careers-summary-bar__item">
                            <p class="careers-summary-bar__job-title">${job.title}</p>
                        </div>
                        <div class="careers-summary-bar__item">
                            <p>${job.location.name} ${remote == true ? '- Remote-friendly' : ''}</p>
                            <p class="careers-summary-bar__view-details">View Details</p>
                        </div>
                    </div>
                </a>`
            );
            jobArray += structuredHTML
        })
    })
    $('#greenhouseJobs').html(jobArray);
}))

